/**
 * Configure and mount Civic Cookie Consent.
 */

import merge from 'lodash.merge';

const DEFAULT_CONFIG = {
	apiKey: '188a6716f36efe5e49b026ee528a7f0650e58e56',
	product: 'PRO_MULTISITE',
	logConsent: true,
	notifyOnce: false,
	initialState: 'NOTIFY',
	position: 'LEFT',
	theme: 'LIGHT',
	layout: 'SLIDEOUT',
	toggleType: 'slider',
	acceptBehaviour: 'all',
	closeOnGlobalChange: true,
	iabCMP: false,
	closeStyle: 'icon',
	consentCookieExpiry: 180,
	subDomains: false,
	mode: 'gdpr',
	rejectButton: true,
	settingsStyle: 'button',
	encodeCookie: false,
	setInnerHTML: true,
	accessibility: {
		accessKey: 'C',
		highlightFocus: false,
		outline: true,
		overlay: true,
	},
	branding: {
		fontColor: '#1a1a1a',
		fontFamily: 'OpenSans-Regular, Arial, sans-serif',
		fontSizeTitle: '1.25em',
		fontSizeHeaders: '1em',
		fontSize: '1em',
		backgroundColor: '#ffffff',
		toggleText: '#fff',
		toggleColor: '#ffffff',
		toggleBackground: '#240f6e',
		alertText: '#fff',
		alertBackground: '#240f6e',
		acceptText: '#ffffff',
		acceptBackground: '#240f6e',
		rejectText: '#1a1a1a',
		rejectBackground: '#f5f5f5',
		closeText: '#111125',
		closeBackground: '#FFF',
		notifyFontColor: '#1a1a1a',
		notifyBackgroundColor: '#f5f5f5',
		buttonIcon: null,
		buttonIconWidth: '64px',
		buttonIconHeight: '64px',
		removeIcon: false,
		removeAbout: true,
	},
	text: {
		title: 'This site uses cookies to store information on your computer.',
		intro: 'Some of these cookies are essential to make our site work and others help us to improve by giving us some insight into how the site is being used. ',
		necessaryTitle: 'Necessary Cookies',
		necessaryDescription: 'These cookies are necessary for the website to function and cannot be switched off in our systems. If you have a blocker plugin set-up on your browser,  some parts of our website may not be displayed. These cookies do not store any personally identifiable information.',
		thirdPartyTitle: 'Warning: Some cookies require your attention',
		thirdPartyDescription: 'Consent for the following cookies could not be automatically revoked. Please follow the link(s) below to opt out manually.',
		on: 'On',
		off: 'Off',
		accept: 'Accept all',
		settings: 'Manage cookies',
		acceptRecommended: 'Accept Recommended Settings',
		acceptSettings: 'Accept all',
		notifyTitle: 'Your choice regarding cookies on this site',
		notifyDescription: 'We use cookies to optimise site functionality and give you the best possible experience.',
		closeLabel: 'Close',
		cornerButton: 'Set cookie preferences.',
		landmark: 'Cookie preferences.',
		showVendors: 'Show vendors within this category',
		thirdPartyCookies: 'This vendor may set third party cookies.',
		readMore: 'Read more',
		accessibilityAlert: 'This site uses cookies to store information. Press accesskey C to learn more about your options.',
		rejectSettings: 'Reject all except necessary',
		reject: 'Reject all',
	},
	necessaryCookies: [ 'wordpress_*', 'wordpress_logged_in_*', 'CookieControl' ],
	optionalCookies: [
		{
			name: 'Functional',
			label: 'Functional',
			description: 'Functional cookies allow us to remember the choices you make on our Site and to provide an enhanced and more personalised experience.',
			cookies: [ '' ],
			recommendedState: 'off',
			lawfulBasis: 'consent',
			onAccept: function () {
				window.gtag( 'consent', 'update', {
					'functionality_storage': 'granted',
					'personalization_storage': 'granted',
				} );
			},
			onRevoke: function () {
				window.gtag( 'consent', 'update', {
					'functionality_storage': 'denied',
					'personalization_storage': 'denied',
				} );
			},
		},
		{
			name: 'Performance',
			label: 'Performance',
			description: 'Performance cookies, also known as analytical cookies, help us to improve our website by collecting and reporting information on its usage.',
			cookies: [ 'kaplan_dm_audience' ],
			recommendedState: 'off',
			lawfulBasis: 'consent',
			onAccept: function () {
				window.gtag( 'consent', 'update', {
					'analytics_storage': 'granted',
				} );
			},
			onRevoke: function () {
				window.gtag( 'consent', 'update', {
					'analytics_storage': 'denied',
				} );
			},
		},
		{
			name: 'Targeting',
			label: 'Targeting',
			description: 'We and our service providers may use targeting or advertising cookies to deliver ads that we believe are more relevant to you and your interests.',
			cookies: [ '' ],
			recommendedState: 'off',
			lawfulBasis: 'consent',
			onAccept: function () {
				window.gtag( 'consent', 'update', {
					'ad_storage': 'granted',
					'ad_user_data': 'granted',
					'ad_personalization': 'granted',
				} );
			},
			onRevoke: function () {
				window.gtag( 'consent', 'update', {
					'ad_storage': 'denied',
					'ad_user_data': 'denied',
					'ad_personalization': 'denied',
				} );
			},
		},
	],
	sameSiteCookie: true,
	sameSiteValue: 'Strict',
	notifyDismissButton: false,
	statement: {
		description: 'For more detailed information, see our',
		name: 'Cookie Policy',
		url: '/cookies',
		updated: '19/05/2023',
	},
};

class CookieConsent {

	constructor( config ) {
		this.config = {};
		merge(
			this.config,
			DEFAULT_CONFIG,
			config
		);
	}

	mount() {
		if ( ! this.config ) {
			throw new TypeError( 'Config should not be empty.' );
		}
		CookieControl.load( this.config );
	}
}

window.kaplanCookieConsent = window.kaplanCookieConsent ?? {};
window.kaplanCookieConsent.CookieConsent = CookieConsent;
